/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


export default class
{
  constructor (userID)
  {
    this.userID = userID;
  }


  matches (zone)
  {
    return zone.getSector().cass.user === this.userID;
  }


  equals (other)
  {
    return other !== null && other.constructor === this.constructor && this.userID === other.userID;
  }


};
